<template>
	<div class="loadingContainer">
		<div class="topGradientContainer"></div>
		<div class="gradientContainer"></div>
		<img :src="image" class="imageBlurBackground" />
		<div class="contentLoadingContainer">
			<img :src="image" />
			<span class="loader"></span>
		</div>
	</div>
	<div class="slowLoading" v-if="slowLoading">
		<div>
			<icon>cloud_off</icon>
			<span>{{ slowLoading }}</span>
		</div>
	</div>
</template>

<script>
import { Variables } from 'InterfaceBundle'

export default {
	name: 'InterfaceLoading',
	data() {
		return {
			image: Variables.getIcon(),
			slowLoading: null
		}
	},
	created() {
		this.slowLoadingCallback = setTimeout(() => {
			const userLang = navigator.language.split('-')[0]
			//Hardcoded translations because not yet loaded
			const messages = {
				en: 'Loading seems slow, check your internet connection',
				fr: 'Le chargement semble lent, vérifiez votre connexion',
				es: 'La carga parece lenta, verifique su conexión a Internet',
				it: 'Il caricamento sembra lento, controlla la tua connessione Internet'
			}
			this.slowLoading = messages[userLang] ? messages[userLang] : messages.en
			this.slowLoadingCallback = null
		}, 5000)
	},
	unmounted() {
		if(this.slowLoadingCallback) clearTimeout(this.slowLoadingCallback)
	}
}
</script>

<style scoped lang="scss">
.imageBlurBackground {
	position: absolute;
	height: 100%;
	object-fit: cover;
	filter: blur(80px);
	max-width: 100%;
	opacity: .5;
}

.loadingContainer {
	position: absolute;
	height: 100%;
	width: 100%;
	background-color: var(--bl-primary);
	display: flex;
	align-items: center;
	justify-content: center;
}

.gradientContainer {
	position: absolute;
	height: 100%;
	width: 100%;
	background: linear-gradient(45deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.3) 100%);
}

.topGradientContainer {
	position: absolute;
	height: 150px;
	width: 100%;
	background: linear-gradient(180deg, var(--bl-primary) 0%, rgba(0,0,0,0) 100%);
	top: 0;
	z-index: 1;
}

.contentLoadingContainer {
	img {
		width: 35vh;
		max-width: 300px;
		margin-bottom: 30px;
		position: relative;
	}

	.loader {
		margin-left: 20%;
		width: 60%;
		height: 5px;
		display: inline-block;
		position: relative;
		background: color-mix(in lch, var(--bl-surface) 90%, var(--bl-primary));
		overflow: hidden;
		border-radius: var(--bl-border-radius);
	}

	.loader::after {
		content: '';
		width: 80%;
		height: 5px;
		background: var(--bl-primary);
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		animation: loaderAnimation 2.5s ease-in-out infinite;
	}

	@keyframes loaderAnimation {
		0% {
			left: 0;
			transform: translateX(-100%);
		}
		100% {
			left: 100%;
			transform: translateX(0%);
		}
	}
}

.slowLoading {
	position: absolute;
	z-index: 1;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	height: 100%;
	width: 100%;

	> div {
		background-color: rgba(0, 0, 0, .8);
		color: white;
		border-radius: var(--bl-border-radius);
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 15px 30px;
		gap: 10px;

		> span {
			font-family: --bl-title;
			font-weight: 700;
		}

		> icon {
			font-size: 18px;
		}
	}
}
</style>